import React from 'react';
import '../../styles/mac-os-ui.css';

const MacClassicWindow = ({ title, activeTab, tabs, subtabs, children }) => {
  return (
    <div className="mac-window">
      <div className="mac-window-header">
        <div className="mac-window-buttons">
          <div className="mac-window-button mac-window-close"></div>
          <div className="mac-window-button mac-window-minimize"></div>
          <div className="mac-window-button mac-window-maximize"></div>
        </div>
        <div className="mac-window-title">{title}</div>
      </div>
      <div className="mac-window-content">
        {tabs && tabs.length > 0 && (
          <div className="mac-tabs">
            {tabs.map((tab, index) => (
              <div 
                key={index}
                className={`mac-tab ${activeTab === tab ? 'active' : ''}`}
                onClick={tab.onClick}
              >
                {tab.label}
              </div>
            ))}
          </div>
        )}
        
        {subtabs && subtabs.length > 0 && (
          <div className="mac-subtabs">
            {subtabs.map((subtab, index) => (
              <div 
                key={index}
                className={`mac-subtab ${subtab.active ? 'active' : ''}`}
                onClick={subtab.onClick}
              >
                {subtab.label}
              </div>
            ))}
          </div>
        )}
        
        <div className="mac-content-section">
          {children}
        </div>
      </div>
    </div>
  );
};

export default React.memo(MacClassicWindow);
